import { render } from "./DetalheFoto.vue?vue&type=template&id=eb2b1e70"
import script from "./DetalheFoto.vue?vue&type=script&lang=js"
export * from "./DetalheFoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__